/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_EmailInputs */

const en_settings_profile_email = /** @type {(inputs: Settings_Profile_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const zh_settings_profile_email = /** @type {(inputs: Settings_Profile_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Settings_Profile_EmailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_profile_email = /** @type {((inputs?: Settings_Profile_EmailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_EmailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_email(inputs)
	return zh_settings_profile_email(inputs)
});
export { settings_profile_email as "settings.profile.email" }